import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
// import CallToActionTwo from '../container/CallToAction/CallToActionTwo';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
// import TopicOne from '../container/topic/TopicOne';
// import EmptyOne from '../components/Empty/EmptyOne.jsx';
import EmptyTwo from "../container/Empty/EmptyTwo.js";

const Topic = () => {
  return (
    <React.Fragment>
      <SEO title="Topic Areas | DMBD 2023" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Topic Areas"
        content="For Authors"
        contentTwo="Topic Areas"
        linkage="/"

      />

      <EmptyTwo>
        <div className="entry-content">
          <table>
            <tbody>
              <tr>
                <th width="140">Data Mining</th>
                <th width="140">Big Data</th>
                <th width="140">FinTech</th>
                <th width="140">Applications</th>
              </tr>
              <tr>
                <td>
                  <ul>
                    <li> Classification and prediction </li>
                    <li> Clustering task</li>
                    <li> Case-Based,Similarity-Based reasoning </li>
                    <li> Mining text, semi-structured, spatio-temporal, streaming, graph,
                      web, multimedia data </li>
                    <li> Systems for data mining </li>
                    <li> Machine learning</li>
                    <li> Reinforcement learning</li>
                    <li> Meta learning</li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li> Data models and architectures </li>
                    <li> Deep learning architectures for handling big data </li>
                    <li> Privacy and security in big data analytics</li>
                    <li> Online and adaptive learning for big data streams </li>
                    <li> Data analytics and metrics </li>
                    <li> Tools and technologies QoS in big data </li>
                    <li> Large-scale text generation model</li>
                    <li> Large-scale generative adversarial network</li>
                    <li> Other large-scale model</li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li>Quantitative investment</li>
                    <li>Intelligent investment strategy</li>
                    <li>Quantitative strategy</li>
                    <li>Quantization system</li>
                    <li>Market microstructure</li>
                    <li>Risk prediction</li>
                    <li>Credit modeling</li>
                    <li>Financial theories</li>
                    <li>Financial intelligent system</li>
                    <li>Financial Large-scale model</li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li> Techniques for Big Data Processing </li>
                    <li>Fraud detection and anomaly detection in large-scale datasets</li>
                    <li>Big data analytics for business intelligence</li>
                    <li>Smart city applications and urban analytics</li>
                    <li>Financial data analysis and stock market prediction</li>
                    <li>Recommender systems for online platforms and personalized recommendations</li>
                    <li>Network security</li>
                    <li>Intelligent diagnosis</li>
                    <li>Other applications</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </EmptyTwo>
      {/* <HomeAbout /> */}
      {/* <EmptyOne>
                <p>
                    yifan
                </p>
            <EmptyOne title="Topic Areas | ICSI 2022"/> */}
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Topic;
